import { render, staticRenderFns } from "./import.vue?vue&type=template&id=6d6c3155&"
import script from "./import.vue?vue&type=script&lang=js&"
export * from "./import.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d6c3155')) {
      api.createRecord('6d6c3155', component.options)
    } else {
      api.reload('6d6c3155', component.options)
    }
    module.hot.accept("./import.vue?vue&type=template&id=6d6c3155&", function () {
      api.rerender('6d6c3155', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/import.vue"
export default component.exports